
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FileInterface } from '@/components/file-browser/interfaces';

const extensionMap: Record<string, string> = {
  '.png': 'mdi-file-png-box',
  '.jpeg': 'mdi-file-jpg-box',
  '.jpg': 'mdi-file-jpg-box',
  '.pdf': 'mdi-file-pdf-box',
}

const mimeTypeMap: Record<string, string> = {
  'image/png': 'mdi-file-png-box',
  'image/jpeg': 'mdi-file-jpg-box',
  'image/jpg': 'mdi-file-jpg-box',
  'application/pdf': 'mdi-file-pdf-box',
}


@Component
export default class FileIcon extends Vue {
  @Prop({ required: true })
  private readonly file: FileInterface;

  get icon(): string {
    if (extensionMap[this.file.extension]) {
      return extensionMap[this.file.extension];
    }

    if (mimeTypeMap[this.file.mimeType]) {
      return mimeTypeMap[this.file.mimeType];
    }

    return 'mdi-file';
  }
}

